module.exports = __webpack_public_path__ + "img/cassette-vhs.72f33b37.svg";